import { DesignSystemColors } from '../../../config/designSystem/Colors';

interface ProgramImagesProps {
    light?: boolean;
    designSystemColor?: DesignSystemColors;
}





// Filenames here must stay free of spaces, commas and '=' characters.
// They used to be the raw Figma exports ("Type=Light, Module=Social.png") and on
// RN 0.86 / New Architecture those simply never painted on iOS: the asset resolved
// to a valid id and Metro served it over HTTP, but the native image loader rendered
// nothing -- which is why the coloured header behind the dashboard's main card was
// blank white. Swapping in a plain-named asset in the same <Image> rendered fine.
const programImages = {
  'light-YELLOW': require('../../../assets/images/Program/light-stress-and-anxiety.png'),
  'default-YELLOW': require('../../../assets/images/Program/default-stress-and-anxiety.png'),

  'light-LIGHT_GREEN': require('../../../assets/images/Program/light-social.png'),
  'default-LIGHT_GREEN': require('../../../assets/images/Program/default-social.png'),

  'light-TURQUOISE': require('../../../assets/images/Program/light-education.png'),
  'default-TURQUOISE': require('../../../assets/images/Program/default-education.png'),

  'light-ELECTRIC_BLUE': require('../../../assets/images/Program/light-self-care.png'),
  'default-ELECTRIC_BLUE': require('../../../assets/images/Program/default-self-care.png'),

  'light-VISTA_BLUE': require('../../../assets/images/Program/light-sleep-well.png'),
  'default-VISTA_BLUE': require('../../../assets/images/Program/default-sleep-well.png'),

  'light-LAVENDER': require('../../../assets/images/Program/light-mood-boost.png'),
  'default-LAVENDER': require('../../../assets/images/Program/default-mood-boost.png'),

  'light-VIOLET': require('../../../assets/images/Program/light-energy-boost.png'),
  'default-VIOLET': require('../../../assets/images/Program/default-energy-boost.png'),

  'light-PINK': require('../../../assets/images/Program/light-self-care.png'),
  'default-PINK': require('../../../assets/images/Program/default-self-care.png'),

  'light-TANGERINE': require('../../../assets/images/Program/light-start-path.png'),
  'default-TANGERINE': require('../../../assets/images/Program/default-start-path.png')
};



export const programImagesFn  = ({light = false, designSystemColor } : ProgramImagesProps) => {
  const DESIGN_SYSTEM_COLOR = designSystemColor || 'TANGERINE';
  const key: keyof typeof programImages = `${light ? 'light' : 'default'}-${DESIGN_SYSTEM_COLOR}`;
  return programImages[key];


};



